module.exports = __webpack_public_path__ + "img/check-blue-circle-icon.39ac3463.svg";